import { render, staticRenderFns } from "./edit-incident.vue?vue&type=template&id=ac30a7c2&scoped=true&"
import script from "./edit-incident.vue?vue&type=script&lang=js&"
export * from "./edit-incident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac30a7c2",
  null
  
)

export default component.exports